import React, { useState } from 'react';
import WelcomePage from './components/WelcomePage';
import CompanionSelection from './components/CompanionSelection';
import Dashboard from './components/Dashboard';
import ZenPlay from './components/ZenPlay';
import Reflect from './components/Reflect';
import Journey from './components/Journey';
import './App.css';
import { usePWAInstall } from './hooks/usePWAInstall';

function App() {
  const { showInstallButton, showInstallPopup, installApp, isStandalone, dismissInstallPrompt, closeInstallPopup } = usePWAInstall();
  const [currentPage, setCurrentPage] = useState('welcome');
  const [selectedCompanion, setSelectedCompanion] = useState('');

  const handleNavigateToCompanion = () => {
    setCurrentPage('companion');
  };

  const handleBackToWelcome = () => {
    setCurrentPage('welcome');
  };

  const handleNavigateToDashboard = (companion) => {
    setSelectedCompanion(companion);
    setCurrentPage('dashboard');
  };

  const handleBackToCompanion = () => {
    setCurrentPage('companion');
  };

  const handleNavigateToZenPlay = () => {
    setCurrentPage('zenplay');
  };

  const handleNavigateToReflect = () => {
    setCurrentPage('reflect');
  };

  const handleBackToDashboard = () => {
    setCurrentPage('dashboard');
  };

  const handleNavigateToJourney = () => {
    setCurrentPage('journey');
  };

  // Add install popup modal
  const renderInstallPopup = () => {
    if (!showInstallPopup || isStandalone) return null;
    
    return (
      <div className="pwa-install-popup-overlay">
        <div className="pwa-install-popup">
          <div className="pwa-popup-header">
            <div className="pwa-popup-icon">📱</div>
            <button className="pwa-popup-close" onClick={closeInstallPopup}>
              ✕
            </button>
          </div>
          <div className="pwa-popup-content">
            <h2>Get the Full Experience!</h2>
            <p>Download the <strong>MoodSync app</strong> for:</p>
            <ul>
              <li>✨ Offline access to all features</li>
              <li>🚀 Faster loading and performance</li>
              <li>📱 App-like experience on your device</li>
              <li>🔔 Push notifications for mood reminders</li>
            </ul>
            <div className="install-note">
              <small>💡 If the install button doesn't work, look for the install icon (⊞) in your browser's address bar or use the Chrome menu option.</small>
            </div>
          </div>
          <div className="pwa-popup-actions">
            <button className="pwa-popup-download" onClick={installApp}>
              <span className="download-icon">⬇️</span>
              Download MoodSync App
            </button>
            <button className="pwa-popup-later" onClick={closeInstallPopup}>
              Maybe Later
            </button>
          </div>
        </div>
      </div>
    );
  };
  const renderInstallButton = () => {
    if (!showInstallButton || isStandalone) return null;
    
    return (
      <div className="pwa-install-banner">
        <div className="pwa-install-content">
          <div className="pwa-install-icon">📱</div>
          <div className="pwa-install-text">
            <h3>Install MoodSync App</h3>
            <p>Get the full app experience with offline access!</p>
          </div>
          <button className="pwa-install-button" onClick={installApp}>
            <span className="install-icon">⬇️</span>
            <span>Install</span>
          </button>
          <button className="pwa-install-dismiss" onClick={dismissInstallPrompt}>
            ✕
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="App">
      {renderInstallButton()}
      {renderInstallPopup()}
      <main>
        {currentPage === 'welcome' && (
          <WelcomePage onNavigateToCompanion={handleNavigateToCompanion} />
        )}
        {currentPage === 'companion' && (
          <CompanionSelection 
            onBack={handleBackToWelcome}
            onContinue={handleNavigateToDashboard}
          />
        )}
        {currentPage === 'dashboard' && (
          <Dashboard 
            selectedCompanion={selectedCompanion}
            onBack={handleBackToCompanion}
            onNavigateToZenPlay={handleNavigateToZenPlay}
            onNavigateToReflect={handleNavigateToReflect}
            onNavigateToJourney={handleNavigateToJourney}
          />
        )}
        {currentPage === 'zenplay' && (
          <ZenPlay 
            onBack={handleBackToDashboard}
            onNavigateToDashboard={handleBackToDashboard}
            onNavigateToReflect={handleNavigateToReflect}
            onNavigateToJourney={handleNavigateToJourney}
          />
        )}
        {currentPage === 'journey' && (
          <Journey 
            onBack={handleBackToDashboard}
            onNavigateToDashboard={handleBackToDashboard}
            onNavigateToReflect={handleNavigateToReflect}
            onNavigateToZenPlay={handleNavigateToZenPlay}
          />
        )}
        {currentPage === 'reflect' && (
          <Reflect 
            onBack={handleBackToDashboard}
            onNavigateToDashboard={handleBackToDashboard}
            onNavigateToZenPlay={handleNavigateToZenPlay}
            onNavigateToJourney={handleNavigateToJourney}
          />
        )}
      </main>
    </div>
  );
}

export default App;